<template>
    <v-container fluid > 
        <v-layout row wrap>
            <v-form>
                <h4>{{$t('labels.researchData')}}</h4><br>
                <v-autocomplete
                    clearable
                    v-model="selectedSpecies"
                    :label="$t('views.SpeciesSingle')"
                    :items="speciesForAutocomplete"
                ></v-autocomplete>
                <v-text-field
                    v-model="research.reference"
                    :counter="100"
                    :label="$t('labels.reference')"
                    required
                ></v-text-field>
                <v-text-field
                    v-model="research.abc"
                    :counter="1"
                    style="max-width:250px;"
                    :label="$t('labels.abc')"
                    required
                ></v-text-field>
                <v-text-field
                    v-model="research.notes"
                    :counter="255"
                    :label="$t('labels.notes')"
                    required
                ></v-text-field>
                <v-switch :label="$t('labels.newSpeciesDescribed')" v-model="research.newSpeciesDescribed" hide-details></v-switch>
                <br>
                <h2 style="text-align:left;">{{$t('labels.continents')}}</h2>
                
                <v-switch :label="$t('labels.africa')" v-model="research.inAfrica" color="success" hide-details></v-switch>
                <v-switch :label="$t('labels.america')" v-model="research.inAmerica" color="success" hide-details></v-switch>
                <v-switch :label="$t('labels.asia')" v-model="research.inAsia" color="success" hide-details></v-switch>
                <v-switch :label="$t('labels.oceania')" v-model="research.inAustralia" color="success" hide-details></v-switch>
                <v-switch :label="$t('labels.europe')" v-model="research.inEurope" color="success" hide-details></v-switch>
                <br>
                <h2 style="text-align:left;">{{$t('labels.anatomicParts')}}</h2>
                <v-switch :label="$t('labels.cranium')" v-model="research.cranium" color="info" hide-details></v-switch>
                <v-switch :label="$t('labels.lowerJaw')" v-model="research.lowerJaw" color="info" hide-details></v-switch>
                <v-switch :label="$t('labels.teeth')" v-model="research.teeth" color="info" hide-details></v-switch>
                <v-switch :label="$t('labels.hyoid')" v-model="research.hyoid" color="info" hide-details></v-switch>
                <v-switch :label="$t('labels.vertebrae')" v-model="research.vertebrae" color="info" hide-details></v-switch>
                <v-switch :label="$t('labels.ribs')" v-model="research.ribs" color="info" hide-details></v-switch>
                <v-switch :label="$t('labels.girdles')" v-model="research.girdles" color="info" hide-details></v-switch>
                <v-switch :label="$t('labels.limbs')" v-model="research.limbs" color="info" hide-details></v-switch>
                <v-switch :label="$t('labels.osteoderms')" v-model="research.osteoderms" color="info" hide-details></v-switch>
                <v-switch :label="$t('labels.shell')" v-model="research.shell" color="info" hide-details></v-switch>
                <br>
                <h2 style="text-align:left;">{{$t('labels.variability')}}</h2>

                <v-switch :label="$t('labels.intraspecificVariation')" v-model="research.intraspecificVariation" color="indigo" hide-details></v-switch>
                <v-switch :label="$t('labels.ontogeneticVariation')" v-model="research.ontogeneticVariation" color="indigo" hide-details></v-switch>
                <v-switch :label="$t('labels.sexDim')" v-model="research.sexDim" color="indigo" hide-details></v-switch>
                <br>
                <h2 style="text-align:left;">{{$t('labels.dataType')}}</h2>

                <v-switch :label="$t('labels.hasDescription')" v-model="research.hasDescription" color="error" hide-details></v-switch>
                <v-switch :label="$t('labels.hasFigure')" v-model="research.hasFigure" color="error" hide-details></v-switch>
                <v-switch :label="$t('labels.hasScoring')" v-model="research.hasScoring" color="error" hide-details></v-switch>
                <v-switch :label="$t('labels.hasGeometricMorphology')" v-model="research.hasGeometricMorphology" color="error" hide-details></v-switch>
                <v-switch :label="$t('labels.hasFiniteElementsAnalysis')" v-model="research.hasFiniteElementsAnalysis" color="error" hide-details></v-switch>

                <br>
                <h2 style="text-align:left;">{{$t('labels.techniques')}}</h2>
                <v-switch :label="$t('labels.drySkeleton')" v-model="research.drySkeleton" color="orange" hide-details></v-switch>
                <v-switch :label="$t('labels.ctScan')" v-model="research.ctScan" color="orange" hide-details></v-switch>
                <v-switch :label="$t('labels.clearingAndStaining')" v-model="research.clearingAndStaining" color="orange" hide-details></v-switch>
                <v-switch :label="$t('labels.xRays')" v-model="research.xRays" color="orange" hide-details></v-switch>
                <v-switch :label="$t('labels.histological')" v-model="research.histological" color="orange" hide-details></v-switch>
                <br><br>
            </v-form>
        </v-layout>
        <v-btn
            dark
            absolute
            bottom
            right
            fab
            color="green"
            style="bottom:20px;"
            @click.native="createResearch()"
            > <v-icon style="font-size:40px;padding-top:5px;">check</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
const axios = require('axios').default;
import SelectTaxonomy from '@/partial/SelectTaxonomy.vue'
export default {
    name: 'SpeciesAdd',
    components: {
        SelectTaxonomy
    },
    data: function(){
        return{
            research:{
                "reference":null,
                "abc":null,
                "notes":null,
                "inAfrica":false,
                "inAmerica":false, 
                "inAsia":false, 
                "inEurope":false, 
                "inAustralia":false, 
                "cranium":false, 
                "lowerJaw":false, 
                "teeth":false, 
                "hyoid":false, 
                "vertebrae":false, 
                "ribs":false, 
                "girdles":false, 
                "limbs":false, 
                "osteoderms":false, 
                "shell":false, 
                "intraspecificVariation":false, 
                "ontogeneticVariation":false, 
                "sexDim":false, 
                "hasDescription":false, 
                "hasFigure":false, 
                "hasScoring":false, 
                "hasGeometricMorphology":false, 
                "hasFiniteElementsAnalysis":false, 
                "drySkeleton":false, 
                "clearingAndStaining":false, 
                "ctScan":false, 
                "xRays":false, 
                "histological":false, 
                "specimenCount":null, 
                "newSpeciesDescribed":false, 
                "reference":null, 
                "year":null, 
                "abc":null, 
                "notes":null, 
                "speciesId":null
            },
            species: [],
            selectedSpecies: null
        };
    },
    mounted: function(){
        let vm = this;
        vm.getSpecies();
    },
    computed: {
        speciesForAutocomplete(){
            let vm = this;
            return vm.species.map(a => a.full);
        },
    },
    methods:{
        getSpeciesIdFromFull(full){
            let vm = this;
            let filteredSpecies = vm.species.filter(s => s.full == full);
            if(filteredSpecies.length>0)
                return filteredSpecies[0].id;
            return null;
        },
        createResearch() {
            let vm = this;
            vm.research.speciesId = vm.getSpeciesIdFromFull(vm.selectedSpecies);
            if (vm.research.speciesId == null){
                alert(vm.$t('labels.missingSpecies'));
                return;
            }
            if (vm.research.reference == null|| vm.research.length<1){
                alert(vm.$t('labels.missingReference'));
                return;
            }
            axios({
                method: "POST",
                url: vm.$API_BASE_URL + "researches/create.php",
                data: vm.research,
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.$router.push({name: 'research', params:{researchId:response.data.id}});
                } 
                else{
                    alert(vm.$t('labels.errorLoading'));
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert(vm.$t('labels.errorLoading'));
                    console.error(error)
                }
            });
        },
        getSpecies(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "species/getCollection.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.species = [];
                    vm.species = response.data.resources;
                } 
                else{
                    alert(vm.$t('labels.errorLoading'));
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert(vm.$t('labels.errorLoading'));
                    console.error(error)
                }
            });
        }
    }
}
</script>

